import { isEmpty } from 'ramda'
import { ReactI18NextChild } from 'react-i18next'
import { useMemo } from 'react'

import EmptyWarn from 'app/common/layouts/EmptyWarn'
import Loading from 'app/common/components/Loader'
import SimpleDate from 'app/common/classes/simple-date'
import { DietFoodTypeId } from 'app/dataTypes/org/dietFoodTypes'

import { useOrgsKitsExtended } from './useOrgsKitsExtended'
import { KitDishesExtended } from './DishesKitExtended/KitDishesExtended'
import { ValidityByDateProvider } from '../../commonComponents/ValidityByDate'

type Props = {
  orgID: string
  orgType: string
  action?: string
  kitID?: string
  buildingId?: number
  dietFoodTypeId?: DietFoodTypeId
  dietFoodTypeTitle?: string
  useGrocerySetPrice: boolean
  useComplexBuildingVariants: boolean
  date: string
  basePath: string
  isNeedToRequest?: boolean
  onSuccessRequest: () => void
  schoolName?: string
}

const KitsListExt = ({
  action,
  orgType,
  orgID,
  kitID,
  buildingId,
  dietFoodTypeId,
  dietFoodTypeTitle,
  useGrocerySetPrice,
  useComplexBuildingVariants,
  date,
  basePath,
  isNeedToRequest,
  onSuccessRequest,
  schoolName,
}: Props): ReactI18NextChild => {
  const { items, loading, refresh } = useOrgsKitsExtended(orgID, {
    date,
    isNeedToRequest,
    buildingId,
    dietFoodTypeId,
    useComplexBuildingVariants,
    onSuccessRequest,
  })
  const nothing = isEmpty(items)

  const currentDate = useMemo(() => {
    return new SimpleDate(date)
  }, [date])

  if (loading && nothing) {
    return <Loading />
  }

  if (nothing) {
    return <EmptyWarn>{'Нет комплектов для выбранного дня'}</EmptyWarn>
  }

  return (
    <ValidityByDateProvider orgID={orgID} currentDate={currentDate}>
      {items.map((item) => (
        <KitDishesExtended
          {...item}
          key={item.id}
          orgID={orgID}
          orgType={orgType}
          kitId={kitID}
          useGrocerySetPrice={useGrocerySetPrice}
          date={date}
          action={action}
          loading={loading}
          basePath={basePath}
          buildingId={buildingId}
          dietFoodTypeId={dietFoodTypeId}
          dietFoodTypeTitle={dietFoodTypeTitle}
          schoolName={schoolName}
          onRefresh={refresh}
        />
      ))}
    </ValidityByDateProvider>
  )
}

export default KitsListExt
